/**
 * Backgrounds registry: maps a {@link BackgroundId} to its component. Like the
 * effects registry, adding a seasonal backdrop is one component + one entry.
 */
import React from 'react';

import { CherryBlossomBackdrop } from './CherryBlossomBackdrop';
import { FallBackdrop } from './FallBackdrop';
import { HalloweenBackdrop } from './HalloweenBackdrop';
import { PatrioticBackdrop } from './PatrioticBackdrop';
import { StPatricksBackdrop } from './StPatricksBackdrop';
import { WinterBackdrop } from './WinterBackdrop';

import type { BackgroundId } from '../decorations';


/** Seasonal background components keyed by id. */
export const BACKGROUND_COMPONENTS: Record<BackgroundId, React.FC> = {
  snowdrifts: WinterBackdrop,
  'halloween-night': HalloweenBackdrop,
  'sakura-fuji': CherryBlossomBackdrop,
  'autumn-hills': FallBackdrop,
  'liberty-skyline': PatrioticBackdrop,
  'shamrock-bunting': StPatricksBackdrop,
};
